import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    setPlanes,
    fetchGrupo,
    setDataGrupo,
    setDataGrupoCopy,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda
} from '../../actions/planesActions';
import { putGrupoPlanes, deleteGrupoPlanesById } from '../../api/axios';
import ModalItem from '../General/Modal';
import GoBackArrow from '../General/GoBackArrow';
import BigSpinner from '../General/BigSpinner';
import { toast } from 'react-toastify';

class PlanesEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comision: 0,
            request: null,
            descripcion: "",
            cambioInputChange: false,
            comisionPredeterminada: ""
        }
    };

    componentDidMount() {
        this.props.fetchGrupoPlanesById({
            numeroPagina: 1,
            cantidadPagina: 500,
            idGrupoPlan: this.props.idGrupo
        });
        this.props.fetchGrupo({ idGrupoPlan: this.props.idGrupo });
        this.props.setPlanes(this.props.planes);
    }
    
    myChangeHandler = (e) => {
        var numbersOnly = /^[0-9.]+$/;
        let valor = e.target.value;

        if (e.target.name === "comision") {

            let esNumero = valor.match(numbersOnly);
            if (esNumero === null) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: "" });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: "" })
                return;
            }
            if (e.target.value > 100) {
                this.setState({ cambioInputChange: true, comisionPredeterminada: 100 });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: 100 })
            } else {
                this.setState({ cambioInputChange: true, comisionPredeterminada: valor });
                this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
            }
        } else {
            this.props.setDataGrupoCopy({ ...this.props.dataGrupo, [e.target.name]: e.target.value })
        }
    }

    onSubmit = async (event) => {
        event.preventDefault();

        if (this.props.dataGrupo.descripcion === "" || this.props.dataGrupo.comision === "") {
            if (this.props.dataGrupo.descripcion === "") {
                toast.error("Debe agregar una descripción");
            }
            if (this.props.dataGrupo.comision === "") {
                toast.error("Debe agregar una comisión");
            }
            return;
        }

        let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
        if (jsonPlanDesdeBusqueda !== "[]") {
            let idPlanes = [];
            for (let index = 0; index < this.props.planDesdeBusqueda.length; index++) {
                idPlanes.push(this.props.planDesdeBusqueda[index].id);
            }
            let data = {
                idGrupoPlan: this.props.idGrupo,
                descripcion: this.props.dataGrupo.descripcion,
                comision: parseFloat(this.props.dataGrupo.comision),
                listaIdsPlanes: idPlanes
            }

            if (JSON.stringify(idPlanes) === "[]") {
                toast.warn("Debe cargar un plan");
                return;
            }

            let post = putGrupoPlanes(data);
            post.then(res => {
                toast.success("Grupo de planes guardado");
                this.return();
            }).catch(err => {
                toast.error("No pudo guardarse");
            });

        } else {
            let idPlanes = [];
            let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);

            if (jsonPlanDesdeBusqueda != "[]") {
                for (let index = 0; index < this.props.planDesdeBusqueda.length; index++) {
                    idPlanes.push(this.props.planDesdeBusqueda[index].id);
                }
            } else {
                for (let index = 0; index < this.props.planes.elementos.length; index++) {
                    idPlanes.push(this.props.planes.elementos[index].idPlan);
                }
            }

            if (JSON.stringify(idPlanes) === "[]") {
                toast.error("Debe cargar un plan");
                return;
            }

            let data = {
                idGrupoPlan: this.props.idGrupo,
                descripcion: this.props.dataGrupo.descripcion,
                comision: parseFloat(this.props.dataGrupo.comision),
                listaIdsPlanes: idPlanes
            }

            let post = putGrupoPlanes(data);
            post.then(res => {
                toast.success("Grupo de planes guardado");
                this.return();
            }).catch(err => {
                toast.error("No pudo guardarse");
            });
        }
    }

    onDelete = () => {
        const req = deleteGrupoPlanesById(this.props.idGrupo);
        req.then(res => {
            toast.success("Grupo de plan borrado");
            this.return();
        }).catch(err => {
            toast.error("No se pudo realizar esta tarea");
        });
    }

    borrarFila = (nroPlan) => {
        let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
        if (jsonPlanDesdeBusqueda !== "[]") {
            let index = this.props.planDesdeBusqueda.findIndex(x => x.numero === nroPlan);
            this.props.planDesdeBusqueda.splice(index, 1);
            this.props.setPlanesDesdeBusqueda(this.props.planDesdeBusqueda);
            this.forceUpdate();
        }
    }

    borrarFilaCargadaInicialmente = (nroPlan) => {
        let index = this.props.planes.elementos.findIndex(x => x.numeroPlan === nroPlan);
        this.props.planes.elementos.splice(index, 1);
        this.props.setPlanes(this.props.planes.elementos);
        this.forceUpdate();
    }

    filaPlanes = () => {
        let jsonPlanDesdeBusqueda = JSON.stringify(this.props.planDesdeBusqueda);
        if (jsonPlanDesdeBusqueda !== "[]") {
            var rows = [];
            let htmlData;
            this.props.planDesdeBusqueda.map((item, index) => {
                htmlData =
                    <tr className="hover-background-color" key={index}>
                        <td>{item.numero}</td>
                        <td>{item.descripcion}</td>
                        <td onClick={() => this.borrarFila(item.numero)}>
                            <i className="fas fa-trash-alt" />
                        </td>
                    </tr>
                rows.push(htmlData)
            });
            return rows;
        } else {
            var rows = [];
            let htmlData;
            let request = JSON.stringify(this.props.planes);
            if (request != "{}") {
                if (this.props.planes.elementos != undefined) {
                    this.props.planes.elementos.map((item, index) => {
                        htmlData =
                            <tr className="hover-background-color" key={index}>
                                <td>{item.numeroPlan}</td>
                                <td>{item.descripcion}</td>
                                <td onClick={() => this.borrarFilaCargadaInicialmente(item.numeroPlan)}>
                                    <i className="fas fa-trash-alt" />
                                </td>
                            </tr>
                        rows.push(htmlData)
                    });
                }
            }
            return rows;
        }
    }

    return = () => {
        this.props.setPlanes([]);
        this.props.history.push("/Planes");
    }

    render() {
        let comision;
        if (this.state.cambioInputChange == false) {
            comision = this.props.dataGrupo.comision != undefined ? this.props.dataGrupo.comision : "";
        } else {
            comision = this.state.comisionPredeterminada;
        }

        return (

            <div className="container card">
                <div className="row justify-content-between align-items-center card-body p-4">

                    <div className="col-10 col-md-5">
                        <GoBackArrow />
                        <h4 className="card-title d-block d-sm-inline">Editar grupo planes</h4>
                    </div>

                    <div className="col-2 col-md-auto button-group">
                        <Link to="/Planes/Busqueda">
                            <button
                                type="button"
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle" /> Agregar Planes
                            </button>
                        </Link>
                    </div>

                    <form className="col-12 form-horizontal form-material" onSubmit={this.onSubmit}>

                        <div className="form-group">
                            <div className="row justify-content-evenly">

                                <div className="col-10 col-md-7">
                                    <label className="label-oscura">Descripción</label>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        value={this.props.dataGrupo.descripcion}
                                        onChange={this.myChangeHandler}
                                        id="firstName"
                                        className="form-control"
                                    />
                                </div>

                                <div className="col-2">
                                    <small className="font-14 applyFont">
                                        <i className="fas fa-percent" />
                                    </small>
                                    <label className="label-oscura mx-2">Comisión</label>
                                    <input
                                        name="comision"
                                        value={comision}
                                        onChange={this.myChangeHandler}
                                        type="text"
                                        className="form-control"
                                        maxLength="5"
                                    />
                                </div>
                            </div>
                        </div>

                        {this.props.isLoading ? <BigSpinner /> :
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Número plan</th>
                                            <th>Descripcion plan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.filaPlanes()
                                        }
                                    </tbody>
                                </table>
                            </div>
                        }

                        <div className="row justify-content-center">
                            <button
                                type="submit"
                                className="btn btn-sm background-rojo-megatone waves-light col-auto mx-2"
                                disabled={this.props.isLoading}
                            >
                                Guardar
                            </button>

                            <ModalItem
                                text="¿Desea eliminar el grupo de plan?"
                                onDelete={this.onDelete}
                                centered
                                show={this.state.showModal}
                                btnText="Eliminar"
                                btnStyle="btn btn-sm btn-grey col-auto mx-2"
                            />

                            <button
                                onClick={this.return}
                                className="btn btn-sm btn-light waves-effect waves-light col-auto mx-2"
                            >
                                Cancelar
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    isLoading: state.planes.loadingPlanes,
    idGrupo: state.planes.id,
    planes: state.planes.grupoPorId,
    planDesdeBusqueda: state.planes.planesDesdeBusqueda,
    dataGrupo: JSON.stringify(state.planes.dataGrupoCopy) !== "{}" 
        ? state.planes.dataGrupoCopy 
        : state.planes.dataGrupo
});

export default connect(mapStateToProps, {
    setPlanes,
    fetchGrupo,
    setDataGrupo,
    setDataGrupoCopy,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda
})(PlanesEdit);